// BULK Trader Revamp
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_REBALANCE_TIMESTAMP } from './bulkTraderBreadcrumb.query';

export function BulkTraderBreadcrumb() {
  const { id } = useParams();
  const { data } = useQuery(FETCH_REBALANCE_TIMESTAMP, {
    variables: { bulkTraderId: id },
    skip: !id,
  });
  const { t } = useTranslation();
  const { localizedDateTime } = useLocalization();

  return (
    <span data-testid='bulk-trader-breadcrumb'>
      {`${t('bulkTrader:bulkTraderOn')} ${data ? localizedDateTime(data.fetchBulkTradeRun?.bulkTradeRun.createdAt) : ''}`}
    </span>
  );
}
